import { RawDraftContentState } from "draft-js";
import { draftToMarkdown } from "markdown-draft-js";

const escapeMarkdownV2Chars = (text: string): string => {
  const specialChars = /[~`>#+=|{}.!-]/g;
  return text.replace(specialChars, "\\$&");
};

const transformAndEscapeMarkdownV2 = (markdown: string): string => {
  let transformedText = markdown
    .replace(/\*\*(?!__)(.*?)\*\*/g, "*$1*")
    .replace(/\*\*__(.*?)__\*\*/g, "*__$1__*");

  return escapeMarkdownV2Chars(transformedText);
};

export const convertDraftToMarkdown = (
  content: RawDraftContentState,
): string => {
  try {
    const options = {
      preserveNewlines: true,
      entityItems: {
        LINK: {
          open: () => "[",
          close: (entity: any) => "](" + entity.data.url + ")",
        },
      },
    };

    const markdown = draftToMarkdown(content, options);

    const cleanedMarkdown = markdown.replace(/\n{3,}/g, "\n\n");

    return transformAndEscapeMarkdownV2(cleanedMarkdown);
  } catch (error) {
    console.error("Conversion to Markdown V2 failed:", error);
    return "";
  }
};
